<template>
    <div class="footer-fixed-icn laser-chat" v-if="$route.name == 'Home'">
        <a href="javascript:void(0)" @click="toggleChatModal()">
            <img  rel="preload"  src="@/assets/images/chat.png">
        </a>
    </div>

    <div class="modal fade laser-chat-modal" id="usernamemodal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content" v-if="iframeUrl">
                <iframe id="chat_modal" :src="iframeUrl" marginwidth="0" marginheight="0" frameborder="0" width="100%"
                    height="100%" scrolling="no" allowfullscreen="allowfullscreen"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChatComponent',
    emits: ['error-modal','success-modal'],
    data() {
        return {
            user_id: null,
            iframeUrl: null,
        }
    },
    computed: {
        userName() {
            return this.$store.getters.stateUser?.userid || null;
        },
    },
    mounted() {
        const guestUserName = localStorage.getItem('guestUserName')
        if (guestUserName && !this.userName && !this.$auth.status) {
            this.user_id = guestUserName;
        } else {
            this.user_id = this.userName
        }
    },
    methods: {
        toggleChatModal() {
            if(!this.iframeUrl) {
                const userid = this.user_id;
                const apiEndpoint = this.$auth.status ? 'GET_CHATBOT_IFRAME' : 'GET_CHATBOT_IFRAME_GUEST';
                const requestData = userid && !this.$auth.status ? { userid } : {};
                this.$apiCall('post', apiEndpoint, requestData).then(response => {
                    window.addEventListener('message', this.handleMessage);
                    this.iframeUrl = response.data.chat_bot_url;
                    this.$helper.openModal('#usernamemodal')
                }).catch(error => {
                    this.$errorToast(error);
                });
            }
        },
        handleMessage(event) {
            if (event.data.userName) {
                this.user_id = event.data.userName;
                localStorage.setItem('guestUserName', this.user_id)
            }
            if (event.data === 'closeChatModal') {
                this.$helper.closeModal('usernamemodal')
                this.iframeUrl = null;
                window.removeEventListener('message', this.handleMessage);
            }
        }
    }
}
</script>

<style>
.chat-back-arrow {
    height: 15px;
    vertical-align: text-top;
}
@media screen and (max-width: 575px) {
    .modal-dialog.thm-chat-modal-sec {
        margin: 0 !important;
    }
}
/* .modal-backdrop {
    z-index: 0 !important;
} */
.laser-chat {
    bottom: 128px !important;
    right: inherit !important;
    left: 13px;
}
</style>